export default "__VITE_ASSET__L73XQcEO__"